import React from "react";
import PropTypes from "prop-types";
import assetify from "@quintype/framework/assetify";
import { Button } from "../../atoms/button";
import subscriptionImage from "../../../../assets/images/nl-images/subsccription banner-on-homepage.png";
import logo from "../../../../assets/images/newslaundry_logo.png";
import { SUBSCRIPTION_PAGE_URL } from "../../../constants";
import "./subscribe-now.m.css";

const SUMMARY =
  "Newslaundry wants to make news a service to the public, not the advertisers. We believe those who make any effort sustainable, determine its direction. You decide.";

export const SubscribeNowTemplate = ({ collection = {} }) => {
  const { name, summary } = collection;
  return (
    <div styleName="row-container">
      <div styleName="container" className="full-width-with-padding">
        <div styleName="left-container">
          <img styleName="logo-wrapper" src={assetify(logo)} alt="newslaundry logo" />
          <h1 styleName="text-container">
            <span styleName="text support">Support</span>
            <span styleName="text-wrapper">
              <span styleName="text">Independent&nbsp;</span>
              <span styleName="text">Media</span>
            </span>
          </h1>
        </div>
        <div styleName="right-container">
          <h2 styleName="title">{name}</h2>
          <div styleName="summary">{summary || SUMMARY}</div>
          <div styleName="btn-img-wrapper">
            <div styleName="subcribe-bottom">
              <Button  href={SUBSCRIPTION_PAGE_URL}>Subscribe Now</Button>
            </div>
            <img styleName="info-image" src={assetify(subscriptionImage)} alt="subscription image" />
          </div>
        </div>
      </div>
    </div>
  );
};

SubscribeNowTemplate.propTypes = {
  collection: PropTypes.object
};
